export default __webpack_public_path__ + "static/media/set-live-background.092681cf.png";